import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OffenseFormComponent } from './offense-form.component'; // Adjust the path as necessary
import { ToastrModule } from 'ngx-toastr'; // Import ToastrModule for notifications
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'; // Import BsDatepickerModule for date pickers
import { FormsModule } from '@angular/forms'; // Import FormsModule for template-driven forms
import { LossesService } from '../../../providers/losses.service'; // Import LossesService
import { MultiTypeService } from '../../../providers/multi-type-service'; // Import MultiTypeService

@NgModule({
  declarations: [
    OffenseFormComponent // Declare the OffenseFormComponent
  ],
  imports: [
    CommonModule, // Import CommonModule for Angular common directives
    ToastrModule.forRoot(), // Import ToastrModule for notifications
    BsDatepickerModule.forRoot(), // Import BsDatepickerModule for date picking
    FormsModule // Import FormsModule to handle form controls
  ],
  providers: [
    LossesService, // Provide LossesService
    MultiTypeService // Provide MultiTypeService
  ],
  exports: [
    OffenseFormComponent // Export OffenseFormComponent for use in other modules
  ]
})
export class OffenseFormModule { }
